import React, { forwardRef, useEffect, useState } from "react";
import Input from "./Input";
import { bm_time, parseToTime } from "../utils/Utils"; // you’ll define these

const TimeField = forwardRef(function TimeField(
    { value, edit, route, onChange, ...rest },
    ref
) {
    const [text, setText] = useState("");
    const [lastValid, setLastValid] = useState("");
    const { onBlur: restOnBlur, ...safeRest } = rest;
    useEffect(() => {
        if (!value) {
            setText("");
            setLastValid("");
            return;
        }

        const formatted = bm_time(value);
        setText(formatted);
        setLastValid(formatted);
    }, [value]);

    const handleBlur = (val) => {

        if(route && window.bm_state.value !== route){
            return; 
        }

        if (!text) {
            // setText("");
            // setLastValid("");
            setTimeout(() => { onChange?.(""); }, 0)
            restOnBlur?.("");
            return;
        } else {
            const ts = parseToTime(text);
            if (ts !== null && bm_time(ts) !== lastValid) {
                const formatted = bm_time(ts);
                setLastValid(formatted);
                onChange?.(ts);
            } else {
                setText(lastValid);
            }
        }
        restOnBlur?.(val);
    };



    return (
        <Input
            {...safeRest}
            ref={ref}
            value={text}
            edit={edit}
            onChange={setText}
            onBlur={handleBlur}
            render={value ? lastValid : ""}
        />
    );
});

export default TimeField;
